import React from 'react';

const BlockingOverlay = ({ shouldDisplay = false }) => {
    return shouldDisplay
        ? <div className="blockingOverlay"></div> : null;
}

export default BlockingOverlay;